export const SPEC_FIELDS = [
  "Origin",
  "Variety / Type",
  "Grade / Size",
  "Quality",
  "Packaging",
  "MOQ",
  "Availability / Season",
  "Shelf Life",
  "Storage",
  "Export Availability",
];
